import { render, staticRenderFns } from "./TipIcon.vue?vue&type=template&id=f0e78346&scoped=true&"
import script from "./TipIcon.vue?vue&type=script&lang=ts&"
export * from "./TipIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TipIcon.vue?vue&type=style&index=0&id=f0e78346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e78346",
  null
  
)

export default component.exports